import React, { useState } from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import Dropzone from './dropzone';
import { setFlag } from 'controllers/flags';
import FileViewer from 'react-file-viewer';
import { expenseParser } from 'controllers/expenseParser/expenseParser';
import { ImageViewer } from 'common';

const useStyles = makeStyles(() => ({
  form: {
    padding: 24,
  },
  formSection: {
    background: '#fff',
    borderRadius: 2,
    marginTop: 24,
  },
  dropZoneContainer: {
    height: 120,
    width: '100%',
    border: '1px dashed #4b8c6f',
  },
  title: {
    opacity: 0.6,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '18px',
    letterSpacing: '0.14px',
    color: '#000000',
    marginBottom: 21,
  },
  btnsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
  },
  btns: {
    width: 144,
    marginRight: 10,
  },
  progress: {
    marginLeft: 8,
  },
  chip: {
    maxWidth: 130,
    marginRight: 7,
  },
  userResume: {
    height: 'auto',
    maxHeight: '45vh',
    overflow: 'scroll',
    border: '2px solid rgb(113 113 113)',
    marginBottom: 15,
    position: 'relative',
    width: '100%',
  },
  userResumeTitle: {
    padding: 9,
    color: 'rgba(255, 255, 255, 0.87)',
    background: 'rgba(0,0,0,0.65)',
    width: 'calc(100% - 18px)',
    zIndex: 1,
    fontSize: 14,
  },
  expenseSelector: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0 0 25px',
  },
  expenseSelectorTitle: {
    marginRight: 35,
    opacity: 0.6,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '20px',
    letterSpacing: '0.24px',
    color: '#000000',
  },
  expenseSelect: {
    flexGrow: 1,
  },
}));

const Form = ({
  setParsedResume,
  parsedResume = null,
  isParsing,
  setIsParsing,
  setPlanId,
  updateCredits,
}) => {
  const classes = useStyles();
  const [docType, setDocType] = useState('receipt');

  const handleDrop = async (files = [], errorFiles = []) => {
    if (errorFiles.length) {
      setFlag('ResumeParserFileTypeError', true);
    }

    if (files.length) {
      onParse(files);
    } else {
      return false;
    }
  };

  const onParse = async (files) => {
    setParsedResume(null);
    setIsParsing(true);

    const response = await expenseParser(files, docType);

    setParsedResume(response);
    setIsParsing(false);
    updateCredits();
  };

  const fileType =
    parsedResume && parsedResume.resumeLink && /[.]/.exec(parsedResume.filename)
      ? /[^.]+$/.exec(parsedResume.filename)[0]
      : undefined;

  return (
    <Grid item xs={5}>
      <div className={classes.formSection}>
        <div className={classes.form}>
          <div className={classes.expenseSelector}>
            <Typography classes={{ root: classes.expenseSelectorTitle }}>
              Select your Document type to Parse:
            </Typography>
            <FormControl variant="outlined" className={classes.expenseSelect}>
              <InputLabel id="select-expense-label">Expense Type</InputLabel>
              <Select
                labelId="select-expense-label"
                id="select-expense"
                value={docType}
                onChange={(e) => {
                  const PLAN_ID_MAP = {
                    receipt: '63d6bdda9ffbd842e0fde22b',
                    invoice: '63de5a0767ec1213b9570431',
                  };

                  setPlanId(PLAN_ID_MAP[e.target.value]);

                  setDocType(e.target.value);
                }}
                label="Expense Type"
              >
                <MenuItem value={'receipt'}>Receipt</MenuItem>
                <MenuItem value={'invoice'} disabled>
                  Invoice (Coming Soon)
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          {parsedResume && parsedResume.resumeLink ? (
            <div className={classes.userResume}>
              <div className={classes.userResumeTitle}>
                {parsedResume.filename}
              </div>
              <div>
                {['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(fileType) ? (
                  <ImageViewer>
                    <div
                      style={{
                        maxHeight: 'calc(45vh - 60px)',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                      }}
                    >
                      <img
                        style={{
                          height: '100%',
                        }}
                        src={parsedResume.resumeLink}
                        alt="document"
                      />
                    </div>
                  </ImageViewer>
                ) : (
                  <FileViewer
                    fileType={fileType}
                    filePath={parsedResume.resumeLink}
                    onError={(e) => console.log(e)}
                  />
                )}
              </div>
            </div>
          ) : null}
          <Typography classes={{ root: classes.title }}>
            Parsing data by uploading the Invoice Receipt. At this point we
            support single file at a time.
          </Typography>
          <Dropzone
            text={'Drag and drop Receipt or Invoice here'}
            subtext={'Upload a .jpeg / .png / .pdf file'}
            handleDrop={handleDrop}
            isLoading={false}
            multiple={false}
          />
        </div>
      </div>
    </Grid>
  );
};

export default Form;
